"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useOnScreen(ref) {
    var observerRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(false), isOnScreen = _a[0], setIsOnScreen = _a[1];
    (0, react_1.useEffect)(function () {
        observerRef.current = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            return setIsOnScreen(entry.isIntersecting);
        });
    }, []);
    (0, react_1.useEffect)(function () {
        var _a;
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            (_a = observerRef === null || observerRef === void 0 ? void 0 : observerRef.current) === null || _a === void 0 ? void 0 : _a.observe(ref.current);
        }
        return function () {
            var _a;
            (_a = observerRef === null || observerRef === void 0 ? void 0 : observerRef.current) === null || _a === void 0 ? void 0 : _a.disconnect();
        };
    }, [ref]);
    return isOnScreen;
}
exports.default = useOnScreen;
